import css from './Input.module.css'

interface InputProps {
    id?: string
    type?: 'text' | 'email' | 'password' | 'number'
    value?: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    placeholder?: string
    disabled?: boolean
    maxLength?: number
    error?: boolean
    testId?: string
}

const Input = ({ id, type = 'text', value, onChange, onKeyDown, placeholder, disabled = false, maxLength, error = false, testId }: InputProps) => {
    return (
        <input
            id={id}
            data-testid={testId}
            type={type}
            className={`${css.input}${error ? ` ${css.error}` : ''}`}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            disabled={disabled}
            maxLength={maxLength}
        />
    )
}

export default Input
